/** Default wait window shown to users while a file is being secured (408). */
export const FILE_PREPARATION_COUNTDOWN_SEC = 30 * 60;

/** How often to re-try the open request while waiting (independent of the countdown window). */
export const FILE_PREPARATION_RETRY_INTERVAL_MS = 30_000;

const COOKIE_PREFIX = 'spx_file_prep_end_';

const getCookie = (name: string): string | undefined => {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : undefined;
};

const setCookie = (name: string, value: string, maxAgeSec: number): void => {
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAgeSec}; SameSite=Lax`;
};

const cookieName = (fileId: string): string => `${COOKIE_PREFIX}${fileId}`;

/**
 * Returns the anchored end timestamp (ms) for a file's preparation countdown.
 * Creates and persists a new anchor in a cookie on first encounter.
 */
export const getOrCreatePreparationEndTime = (fileId: string): number => {
    const name = cookieName(fileId);
    const existing = getCookie(name);
    if (existing) {
        const parsed = Number(existing);
        if (!Number.isNaN(parsed) && parsed > Date.now()) {
            return parsed;
        }
    }
    const endTime = Date.now() + FILE_PREPARATION_COUNTDOWN_SEC * 1000;
    setCookie(name, String(endTime), FILE_PREPARATION_COUNTDOWN_SEC);
    return endTime;
};

/** Remaining seconds until the given end timestamp, clamped at 0. */
export const getRemainingSeconds = (endTimeMs: number): number => (
    Math.max(0, Math.ceil((endTimeMs - Date.now()) / 1000))
);

/** Formats seconds as m:ss for the countdown label. */
export const formatCountdown = (totalSeconds: number): string => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};
